














import { computed, defineComponent, PropType, ref } from "@vue/composition-api";
import { UserPublicData } from "@scrile/api-provider/dist/projects/scrileConnect/UserPublicDataProvider";
import useDarkModeController from "@/hooks/useDarkModeController";
import { darkModeReplacePostfix } from "@/lib/darkModeReplacePostfix";
import { translateLabelsInFields } from "@/lib/formHelpers";
import { getQuestionaryInfoFields, getValues } from "@/lib/questionaryFieldsHelper";
import { FormFields, FormValues } from "@/types";
import BaseButton from "@/components/BaseButton";
import BaseForm from "@/components/BaseForm";
import ModalView from "@/components/ModalView";

export default defineComponent({
  name: "ModalSocialMediaAccountsEdit",
  components: { BaseForm, ModalView, BaseButton },
  props: {
    questionaryInfo: { type: Object as PropType<Record<string, string>>, required: true },
    user: { type: Object as PropType<UserPublicData> },
  },
  setup(props, { emit }) {
    const { isDarkMode } = useDarkModeController();
    const processing = ref(false);

    const socialFields = computed<FormFields>(() => {
      const fields = getQuestionaryInfoFields().filter(i => i.fieldMeta?.social);
      return translateLabelsInFields(
        fields.map(i =>
          i.appendIcon ? { ...i, appendIcon: darkModeReplacePostfix(i.appendIcon, isDarkMode.value) } : i
        )
      );
    });

    const socialFieldsValues = ref<FormValues>(getValues(socialFields.value, props.questionaryInfo));

    const save = () => {
      processing.value = true;
      emit("save", socialFieldsValues.value);
    };

    return {
      socialFieldsValues,
      socialFields,
      processing,
      save,
    };
  },
});
